import type { RelatedPostsSection } from "@/types/content";
import ArticleCard from "@/components/base/ArticleCard";

interface Props {
  section: RelatedPostsSection;
}


export default function RelatedPostsSectionBlock({ section }: Props) {
  if (!section.posts || section.posts.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        {section.title && (
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-8">
            {section.title}
          </h2>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.posts.map((post) => (
            <ArticleCard
              key={post.id}
              post={post}
              padding="compact"
              footer={
                <div className="flex items-center gap-3 text-xs text-slate-400">
                  <span>{post.publishedAt}</span>
                  <span>{post.readingTime} 分鐘閱讀</span>
                </div>
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}